import { useState } from 'react'

import {
  ContactFragment,
  CreateProjectDocument,
  CreateProjectMutation,
  CreateProjectMutationVariables,
  ProjectsDataCollectionDocument,
} from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import AddProjectWizard from 'modules/project_management/components/wizards/AddProjectWizard'

interface Props {
  client: ContactFragment
  onClose: () => void
  onSuccess: () => void
}

export const CreateWizard = ({ client, onClose, onSuccess }: Props) => {
  const [debounceAddProject, setDebounceAddProject] = useState(true)

  const [create] = useMutation(CreateProjectDocument, {
    extractorFn: (data: CreateProjectMutation) =>
      data.projectManagementMutations.createProjectmanagementProject,
  })

  const createProject = (dto: CreateProjectMutationVariables) => {
    return create({
      variables: dto,
      awaitRefetchQueries: true,
      refetchQueries: [ProjectsDataCollectionDocument],
    })
  }

  useEffect(() => {
    track(trackingEvents.projectManagement.clients.wizard.createProjectClientButtonProjectWizard)

    // Hack for Wizard. Wizard have a bug causing unexpected closes when opening.
    // For that, we can fix it temporally locking the modal a few ms
    setTimeout(() => setDebounceAddProject(false), 200)
  }, [])

  return (
    <AddProjectWizard
      onClose={onClose}
      create={createProject}
      client={client}
      locked={debounceAddProject}
      onSuccess={() => {
        track(trackingEvents.projectManagement.clients.wizard.addClientProjectSubmitProjectWizard)

        onSuccess()
      }}
    />
  )
}
